import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { InputDataWithDefaults } from "./calendar/model";
import { defaultInputState } from "./calendar/inputState";
import { getCurrentWeek } from "./calendar/carouselCalendar/legacyUtils";

const inputState = { ...defaultInputState };

const renderCalendar = (calendarSettings: InputDataWithDefaults) => {
    const rootElement = document.querySelector(calendarSettings.container);
    const root = ReactDOM.createRoot(rootElement!);

    const doRender = () => {
        inputState.version++;

        root.render(
            React.createElement(
                App,
                { inputData: calendarSettings, inputState },
                null
            )
        );
    };

    doRender();

    const getOffsetFromDate = (datum: Date) =>
        getCurrentWeek(datum) - getCurrentWeek();

    const setWeek = (weekOffsetOrDate: number | string | Date) => {
        switch (typeof weekOffsetOrDate) {
            case "number":
                inputState.weekOffset = weekOffsetOrDate;
                break;
            case "string":
                inputState.weekOffset = getOffsetFromDate(
                    new Date(weekOffsetOrDate)
                );
                break;
            case "object":
                inputState.weekOffset = getOffsetFromDate(weekOffsetOrDate);
                break;
        }
    };

    return {
        jumpToOverviewWeek: (weekOffsetOrDate: number | string | Date) => {
            setWeek(weekOffsetOrDate);

            doRender();
        },
        jumpToRegularWeek: (weekOffsetOrDate: number | string | Date) => {
            setWeek(weekOffsetOrDate);
            inputState.modalOpen = true;
            inputState.isRegular = true;

            doRender();
        },
        jumpToIndividualWeek: (weekOffsetOrDate: number | string | Date) => {
            setWeek(weekOffsetOrDate);
            inputState.modalOpen = true;
            inputState.isRegular = false;

            doRender();
        },
        showSettingsModal: () => {
            inputState.modalOpen = true;

            doRender();
        },
        hideSettingsModal: () => {
            inputState.modalOpen = false;

            doRender();
        },
        changeSettingState: (state: "regular" | "individual") => {
            inputState.isRegular = state === "regular";
        },
        destroy: () => {
            root.unmount();
        },
    };
};

export default renderCalendar;
